export const LAST_USED_LOGIN_METHOD_STORAGE_KEY =
  'autoclipper:last-used-login-method';

export type LoginMethod = 'password' | 'google';

type LoginMethodStorage = Pick<Storage, 'getItem' | 'setItem'>;

export function getLastUsedLoginMethod(
  storage: LoginMethodStorage,
): LoginMethod | null {
  try {
    const value = storage.getItem(LAST_USED_LOGIN_METHOD_STORAGE_KEY);
    return value === 'password' || value === 'google' ? value : null;
  } catch {
    return null;
  }
}

export function rememberLastUsedLoginMethod(
  storage: LoginMethodStorage,
  method: LoginMethod,
): void {
  try {
    storage.setItem(LAST_USED_LOGIN_METHOD_STORAGE_KEY, method);
  } catch {
    // Authentication must still succeed when browser storage is unavailable.
  }
}
